import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import Logo from "../../assets/OGOGLOGOG.svg"; // Ensure the logo path is correct
import navConfig from "../../config/navConfig";
import { HiOutlineChevronDown } from "react-icons/hi2";
import { Tooltip } from "@heroui/react";
import { AllLeadsIcon } from "../../utils/svgIcons";

const MobileSideBar = ({ collapsed, allowedRoutes, isMobileMenuOpen, setIsMobileMenuOpen }) => {
    const location = useLocation();
    const [openDropdown, setOpenDropdown] = useState(null);

    useEffect(() => {
        const parentWithActiveChild = navConfig.items.find(item =>
            item.children?.some(child => location.pathname.startsWith(child.url))
        );
        if (parentWithActiveChild) {
            setOpenDropdown(parentWithActiveChild.key);
        }
    }, [location.pathname]);

    const toggleDropdown = (key) => {
        setOpenDropdown((prev) => (prev === key ? null : key));
    };

    const sortedNavItems = (allowedRoutes || []).filter(item => item.key !== "PROTECTED")
    // .filter(item => item.key && item.key !== "PROTECTED" && allowedRoutes.some(allowed => allowed.key === item.key))
    // .sort((a, b) => a.name.localeCompare(b.name));

    return (

        <div>
            {/* Overlay */}
            <div
                className={`fixed inset-0 bg-black bg-opacity-50 transition-opacity duration-300 z-40 ${isMobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
                    }`}
                onClick={() => setIsMobileMenuOpen(true)}
            ></div>

            {/* Sidebar */}
            <div
                className={`fixed top-0 left-0 h-screen w-[300px] bg-white shadow-lg transform transition-transform duration-300 z-50 overflow-x-hidden overflow-y-scroll default-scrollbar ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
                    }`}
            >
                {/* Close Button */}
                <button
                    onClick={() => setIsMobileMenuOpen(false)}
                    className="absolute top-4 right-4 text-gray-500 hover:text-black"
                >
                    ✕
                </button>

                <aside
                    className={`default-scrollbar overflow-y-auto  bg-white rounded-outSideglobal text-black p-4 transition-width duration-300 w-[300px]`}
                >
                    {/* Logo Section */}
                    <div
                        className={`flex items-center mb-6 transition-all duration-300 gap-2 justify-start`}
                    >
                        <div className="image w-14">
                            <img className="w-20 h-20 mx-auto" src={Logo} alt="Logo" />
                        </div>
                        <h1 className="inline-flex italic font-bold text-3xl transition-all duration-300">
                            EVINDIA
                        </h1>
                    </div>

                    {/* Navigation */}
                    <nav>
                        <ul>
                            {sortedNavItems
                                .map((item, index) => {
                                    const sortedChildren = item.children
                                        ? [...item.children].sort((a, b) => a.name.localeCompare(b.name))
                                        : [];
                                    return (
                                        <li key={`menu-${item.key}-${index}`} className="mb-1">
                                            {item.children && item.children.length > 0 ? (
                                                <div className="flex flex-col">
                                                    <NavLink
                                                        key={`nav-${item.key}-${index}`}
                                                        onClick={() => toggleDropdown(item.key)}
                                                        to={item.url}
                                                        className={({ isActive }) =>
                                                            `px-4 py-[15px] h-14 w-full text-[14px] flex relative !text-nowrap before:bg-beforeColor before:absolute before:top-0 before:bottom-0 before:left-[-16px] before:right-0 before:h-full before:w-0 before:z-10 before:rounded-newradius hover:before:w-[calc(100%_+_16px)] before:transition-width before:duration-300 ${isActive
                                                                ? " before:w-[calc(100%_+_16px)] text-[#0085db]"
                                                                : "hover:text-blue-400 before:w-[0px] hover:before:bg-[#e7ecf0]"
                                                            }`
                                                        }
                                                    >
                                                        <div className="flex items-center gap-2 z-20">
                                                            {item.icon ? item.icon : <AllLeadsIcon />}
                                                            {item.name}
                                                            <HiOutlineChevronDown
                                                                className={`transition-transform duration-300 ${openDropdown === item.key ? "rotate-180" : "rotate-0"
                                                                    }`}
                                                            />
                                                        </div>
                                                    </NavLink>

                                                    <div className={`overflow-hidden pl-0 ml-4 transition-all duration-400 ${openDropdown === item.key
                                                        ? "max-h-[800px] opacity-100 pt-2 pb-2 border-l border-gray-100"
                                                        : "max-h-0 opacity-0 pointer-events-none"
                                                        }`}>
                                                        {
                                                            sortedChildren.map((child, inc) => (
                                                                <NavLink
                                                                    key={`child-${child.key}-${index}-${inc}}`}
                                                                    to={child.url}
                                                                    onClick={() => setIsMobileMenuOpen(false)}
                                                                    className={({ isActive }) =>
                                                                        `mb-1 px-4 py-[15px] text-[14px] h-12 w-full flex relative before:bg-beforeColor before:absolute before:top-0 before:bottom-0 before:left-[-0px] before:right-0 before:h-full before:w-0 before:z-10 before:rounded-newradius hover:before:w-[calc(100%_+_0px)] before:transition-width before:duration-300 ${isActive
                                                                            ? " before:w-[calc(100%_+_0px)] text-[#0085db]"
                                                                            : "hover:text-blue-400 before:w-[0px] hover:before:bg-[#e7ecf0]"
                                                                        }`
                                                                    }
                                                                >
                                                                    <div className="flex items-center gap-2 z-20 children-routes-box">
                                                                        {child.icon ? child.icon : <AllLeadsIcon />}
                                                                        {child.name}
                                                                    </div>
                                                                </NavLink>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            ) : (
                                                <NavLink
                                                    to={item.url}
                                                    onClick={() => setIsMobileMenuOpen(false)}
                                                    className={({ isActive }) =>
                                                        `px-4 py-[15px] h-14 w-full text-[14px] flex relative before:bg-beforeColor before:absolute before:top-0 before:bottom-0 before:left-[-16px] before:right-0 before:h-full before:w-0 before:z-10 before:rounded-newradius hover:before:w-[calc(100%_+_16px)] before:transition-width before:duration-300 ${isActive
                                                            ? " before:w-[calc(100%_+_16px)] text-[#0085db]"
                                                            : "hover:text-blue-400 before:w-[0px] hover:before:bg-[#e7ecf0]"
                                                        }`
                                                    }
                                                >
                                                    <div className="flex items-center gap-2 z-20">
                                                        {item.icon ? item.icon : <AllLeadsIcon />}
                                                        {item.name}
                                                    </div>
                                                </NavLink>
                                            )}

                                        </li>
                                    )
                                }
                                )}
                        </ul>
                    </nav>
                </aside >
            </div>
        </div>

    );
};

export default MobileSideBar;
